import { SelectedState } from "../../lib/selected-state.js";
import { formatCurrency } from "../../lib/utils.js";
import { html } from "lit";
import { property, customElement } from "lit/decorators.js";
import "../../common/legal-disclaimer.js";
import "../../common/descriptor-list.js";
import "../../common/promotional-description.js";
import "../../common/offer-header.js";
import "../../common/landing-page-action.js";
import { MultiOfferQuoteElement } from "../../lib/multi-offer-element.js";
import { when } from "lit/directives/when.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
let RegistrationCancellation = class extends MultiOfferQuoteElement {
  constructor() {
    super("registration-cancellation");
  }
  /**
   * @ignore 
   */
  _renderMultiDisplay() {
    var _a, _b, _c;
    return html`
      <offer-checkbox-button @change=${this.toggleOfferSelection} ?checked=${this.selectedState === SelectedState.ACCEPTED}>
        <div class="multi-offer-item">
          <div>Include Coverage for ${this.participantFirstName} ${this.participantLastName} ${when(this.coverageContextDescription, () => html`(${this.coverageContextDescription})`)}</div>
          <div>${((_a = this.quote) == null ? void 0 : _a.total) || ((_b = this.quote) == null ? void 0 : _b.premium_amount) ? formatCurrency(((_c = this.quote) == null ? void 0 : _c.total) || this.quote.premium_amount, this.quote.currency) : ""}</div>
        </div>
      </offer-checkbox-button>
    `;
  }
  /**
   * @ignore 
   */
  get policyAttributes() {
    return {
      insurable_amount: this.insurableAmount,
      participant: {
        first_name: this.participantFirstName,
        last_name: this.participantLastName
      },
      event_start_date: this.eventStartDate,
      event_end_date: this.eventEndDate
    };
  }
};
RegistrationCancellation.styles = [
  MultiOfferQuoteElement.styles
];
__decorateClass([
  property({ type: Number, attribute: "insurable-amount" })
], RegistrationCancellation.prototype, "insurableAmount", 2);
__decorateClass([
  property({ attribute: "event-start-date" })
], RegistrationCancellation.prototype, "eventStartDate", 2);
__decorateClass([
  property({ attribute: "event-end-date" })
], RegistrationCancellation.prototype, "eventEndDate", 2);
__decorateClass([
  property({ attribute: "participant-first-name" })
], RegistrationCancellation.prototype, "participantFirstName", 2);
__decorateClass([
  property({ attribute: "participant-last-name" })
], RegistrationCancellation.prototype, "participantLastName", 2);
RegistrationCancellation = __decorateClass([
  customElement("registration-cancellation")
], RegistrationCancellation);
export {
  RegistrationCancellation
};
